import { Icon } from '@acme/assets';
import type { OrganizationResponse, UserResponse } from '@acme/domains';
import { Skeleton } from '@acme/foundation';
interface OrganizationInfoProps {
  children?: React.ReactNode;
  organization: OrganizationResponse | null;
  user: UserResponse | null;
  isLoading: boolean;
}

export const OrganizationInfo = ({
  children,
  user,
  organization,
  isLoading,
}: OrganizationInfoProps) => {
  return (
    <div className="font-inter flex w-full flex-col bg-gray-100 rounded-lg p-4">
      <div className="flex w-full items-center gap-3">
        <Icon name="factory" size={24} className="text-green-900" />
        <div className="flex flex-col flex-grow gap-1">
          {isLoading ? (
            <>
              <Skeleton className="h-5 w-40" />
              <Skeleton className="h-4 w-32" />
            </>
          ) : (
            <>
              <div className="font-semibold text-base leading-5">
                {organization?.name}
              </div>
              <div className="text-text-secondary text-sm leading-5">
                ИНН: {organization?.inn}
              </div>
            </>
          )}
        </div>
      </div>

      <div className="ml-[36px] mr-0 border-b border-gray-300 my-4" />

      <div className="flex w-full items-center gap-3 ">
        <Icon name="user-circle-outline" size={24} className="text-green-900" />
        <div className="flex flex-col flex-grow">
          {isLoading ? (
            <Skeleton className="h-5 w-32" />
          ) : (
            <div className="font-medium text-base leading-6">
              {user?.person?.name}
            </div>
          )}
        </div>
      </div>

      {children}
    </div>
  );
};
